import templateFormController from './template.form.controller';

export default {
    bindings: {
        resolve: '<'
    },
    controller: templateFormController,
    template: require('./template.form.html')
};
